import { challengeMock } from "../../mocks/challenge";
import { store } from "../../store";
import { getFetchConfig, handleRawResponse, handleJsonResponse, urlAddTenant, NETWORK_WARNINGS_ACTIVE, NETWORK_WARNINGS_INACTIVE } from ".";
import { SET_TEST_DATA, SET_VIDEO_ID, ERROR_MESSAGE } from "../livenessTest";
import { UPDATE_MESSAGE } from "../faceLiveness3D";
import { delayedPromise } from "../../delayedPromise";

/**
 * POST /{tenant}/DigitalOnBoardingServices/rest/v1/users/{userId}/idchecks/{idCheckId}/challenges?livenessPolicyName={livenessPolicyName}
 */
export const challengeCreate = () => dispatch => {
  dispatch({ type: NETWORK_WARNINGS_ACTIVE });
  let promise = null;
  if (process.env.REACT_APP_MOCK_API === "true") {
    promise = delayedPromise(challengeMock);
  } else {
    const { application, configuration } = store.getState();
    const controller = new AbortController();
    const signal = controller.signal;
    setTimeout(() => {
      controller.abort();
    }, 30000)
    promise = fetch(urlAddTenant(`/DigitalOnBoardingServices/rest/v1/users/${application.user.id}/idchecks/${application.user.idCheck.id}/challenges?livenessPolicyName=${configuration.livenessPolicyName}`), {
      ...getFetchConfig(),
      method: "POST",
      signal,
      credentials: 'same-origin',
    })
      .then((rawResponse) => {
        return handleRawResponse(rawResponse)
          .then((res) => handleJsonResponse(res, rawResponse.ok))
      })
  }

  return promise.then(payload => {
    dispatch({ type: NETWORK_WARNINGS_INACTIVE });
    dispatch({ type: SET_TEST_DATA, payload });
    return payload;
  })
}

/**
 * POST /{tenant}/DigitalOnBoardingServices/rest/v1/users/{userId}/idchecks/{idCheckId}/videos/?{videoId | ""}
 */
export const challengeTemplateUpload = base64Template => dispatch => {
  dispatch({ type: NETWORK_WARNINGS_ACTIVE });
  const controller = new AbortController();
  const signal = controller.signal;
  setTimeout(() => {
    controller.abort();
  }, 30000)

  dispatch({ type: UPDATE_MESSAGE, payload: "" });
  const { application, livenessTest } = store.getState();
  let promise = null;
  if (process.env.REACT_APP_MOCK_API === "true") {
    promise = delayedPromise({
      id: 1,
      processingStatus: 'PROCESSED'
    });
  } else {
    const subtype = livenessTest.livenessTestData.items[0].type === "SVR3DFL" ? "SVR3DFL_CHALLENGE" : "WEB_CLR";
    const request = {
      "subtype": subtype,
      "captured": new Date().toISOString(),
      "videoFormat": livenessTest.livenessTestData.items[0].type,
      "challenges": [
        {
          "challenge": {
            "id": livenessTest.livenessTestData.items[0].id,
            "type": livenessTest.livenessTestData.items[0].type,
          },
          "start": 0,
          "completed": 99999
        }
      ],
      "sensitiveData": {
        "format": livenessTest.livenessTestData.items[0].type,
        "value": base64Template
      }
    };
    promise = fetch(urlAddTenant(`/DigitalOnBoardingServices/rest/v1/users/${application.user.id}/idchecks/${application.user.idCheck.id}/videos/${livenessTest.videoId || ""}`), {
      ...getFetchConfig(),
      method: "POST",
      credentials: 'same-origin',
      body: JSON.stringify(request),
      signal
    })
      .then(handleRawResponse);
  }

  return promise
    .then(response => {
      dispatch({ type: NETWORK_WARNINGS_INACTIVE });
      if (response.processingStatus === 'FAILED') {
        dispatch({ type: ERROR_MESSAGE, payload: response.processingErrors.items[0].message });
      }

      if (response.id) {
        dispatch({ type: SET_VIDEO_ID, payload: response.id });
      }
      return response;
    })
}